/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v3";
import { ClosedEnum } from "../../types/enums.js";

export const TransferWaitFor = {
  RailResponse: "rail-response",
} as const;
export type TransferWaitFor = ClosedEnum<typeof TransferWaitFor>;

/** @internal */
export const TransferWaitFor$inboundSchema: z.ZodNativeEnum<
  typeof TransferWaitFor
> = z.nativeEnum(TransferWaitFor);
/** @internal */
export const TransferWaitFor$outboundSchema: z.ZodNativeEnum<
  typeof TransferWaitFor
> = TransferWaitFor$inboundSchema;
